var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "yxtbiz-rule-cycle" },
    [
      _c(
        "yxt-radio-group",
        {
          on: { change: _vm.onChange },
          model: {
            value: _vm.formData.ruleCycle,
            callback: function ($$v) {
              _vm.$set(_vm.formData, "ruleCycle", $$v)
            },
            expression: "formData.ruleCycle",
          },
        },
        _vm._l(_vm.typeOps, function (item) {
          return _c(
            "yxt-radio",
            { key: item.value, attrs: { label: item.value } },
            [_vm._v(_vm._s(item.label))]
          )
        }),
        1
      ),
      _vm.showTimes
        ? _c(
            "div",
            { staticClass: "mt16" },
            [
              _c("span", [
                _vm._v(
                  _vm._s(
                    _vm.$t("pc_biz_rule_cycle_valid_times" /*'周期内最多生效'*/)
                  )
                ),
              ]),
              _c("yxt-input-number", {
                staticClass: "mh8",
                attrs: { precision: 0, min: 1 },
                model: {
                  value: _vm.formData.cycleTimes,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "cycleTimes", $$v)
                  },
                  expression: "formData.cycleTimes",
                },
              }),
              _c("span", [
                _vm._v(_vm._s(_vm.$t("pc_biz_rule_cycle_times" /*'次'*/))),
              ]),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }